<template>
  <story-layout :iframeSrc="imgSource.eduTempsl" iframeId="portfolio-cardc">
    <template #rightCom>
      <div v-if="showDialog" class="cus-dialog">
        <StoryLayoutRight
          :src="imgSource.eduCoverPic"
          btnText="开启教育规划"
          @click="showDialog = false"
        />
      </div>
      <div v-else>
        <module-header class="right-main" title="基础家庭信息" />
        <base-info />
      </div>
    </template>
  </story-layout>
</template>
<script>
import { Component, Vue } from "vue-property-decorator";
import StoryLayout from "@/common/cardMap/storyLayout/index.vue";
import StoryLayoutRight from "@/common/cardMap/storyLayout/rightImgText.vue";
import { CommonMudule } from "@/store/modules/common";
import { getFinancialAnalysisInfo } from "@/api/articles";
import moduleHeader from "@/components/moduleHeader/index.vue";
import baseInfo from "./template/index";
@Component({
  name: "childTeach",
  components: {
    moduleHeader,
    baseInfo,
    StoryLayout,
    StoryLayoutRight,
  },
})
export default class extends Vue {
  showDialog = true;
  get imgSource() {
    return CommonMudule.imgSource;
  }
  async created() {
    const res = await getFinancialAnalysisInfo({
      customerId: CommonMudule.customerId,
    });
    if (
      res?.data.customerMember?.outAmount !== 0 &&
      res?.data.customerMember?.inAmount !== 0 &&
      res?.data.customer?.familyStatus
    ) {
      this.showDialog = false;
    }
  }
}
</script>
